export const BASE_URL = 'https://api.alfadent.digifeel.cz/';



// WEBPACK FOOTER //
// ./src/appConfig.js